export default {
	beforeDatasetsDraw: (context) => {
		const activePoint = context?.tooltip?._active?.[0];
		if (!activePoint || /^(bar|pie)$/.test(context.config.type)) return;

		const ctx = context.ctx;

		// Draw Tooltip Annotation Line
		ctx.save();
		ctx.beginPath();
		ctx.strokeStyle = '#fff';
		ctx.lineWidth = 1;
		ctx.moveTo(activePoint.element.x, context.chartArea.top);
		ctx.lineTo(activePoint.element.x, context.chartArea.bottom);
		ctx.stroke();
		ctx.restore();
	},
};
